import actions from '@devices/settings/device_settings/actions.js';
import internet from '@devices/settings/device_settings/internet.js';
import app from '@devices/settings/device_settings/app.js';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'shellybutton1',
	friendly_name: 'Button',
	family: 'inputs_reader',
	isPM: false,
	modes: {
		inputs_reader: {
			channels: 1,
			notifications: ['offline', 'device_problem'],
			settings: [
				actions,
				internet,
				app,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'long_push', component: 'long_push_inputs' },
						{ title: 'multi_push', component: 'multi_push' },
						{ title: 'remain_awake', component: 'remain_awake' },
						{ title: 'led_status_disable', component: 'led_status_disable' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{
							title: 'geo_location_and_time_zone',
							component: 'geo_location_and_time_zone',
						},
						{ title: 'device_name', component: 'device_name' },
						{ title: 'factory_reset', component: 'factory_reset_g1' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
